(function() { module.exports = window["Next"]["Collapse"]; }());